import { useMemo } from 'react';
import { isBefore } from 'date-fns';
import { Popover } from 'app/agriculture/components/Popover/Popover';
import { TimelinePelletContent, TimelinePelletContentProps } from './TimelinePelletContent';
import { TimelinePelletContainer, TimelinePelletContainerProps } from './TimelinePelletContainer';
import './TimelinePellet.scss';

export type TimelinePelletProps = TimelinePelletContainerProps &
    TimelinePelletContentProps & {
        popoverContent?: React.ReactNode;
        id: string;
    };

export function TimelinePellet({
    id,
    Icon,
    text,
    color,
    interval,
    popoverContent,
    disabled,
}: TimelinePelletProps) {
    const content = useMemo(
        () => <TimelinePelletContent {...{ id, Icon, text, color, disabled }} />,
        [id, Icon, text, color, disabled],
    );

    const popover = useMemo(
        () => (
            <Popover>
                <Popover.Trigger>{content}</Popover.Trigger>
                <Popover.Content disablePadding>{popoverContent}</Popover.Content>
            </Popover>
        ),
        [content, popoverContent],
    );

    if (isBefore(interval.end, interval.start)) return null;

    return (
        <TimelinePelletContainer {...{ id, interval }}>
            {popoverContent == null ? content : popover}
        </TimelinePelletContainer>
    );
}
